import { Box, Flex, Text, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'

const ProductIntro: React.FC = () => {
  return (
    <Box h="100%">
      <Flex
        direction={['column', 'column', 'column', 'row']}
        gap={['20px', '20px', '20px', '60px']}
        py={['20px', '20px', '50px']}
        alignItems="center"
      >
        <Box w={['100%', '100%', '100%', '45%']} h="100%">
          <AspectRatio ratio={264 / 263} w="100%" position="relative">
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/1738752377072-1738752757558.jpg"
              alt="zero-2-one product intro"
              fill
            />
          </AspectRatio>
        </Box>

        <Flex
          direction="column"
          gap={['10px', '10px', '20px']}
          py={['20px', '20px', '50px']}
          flex="1"
        >
          <Flex justifyContent="center">
            <Box w="280px" h="100%">
              <AspectRatio ratio={500 / 229} w="100%" position="relative">
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/image-1736911385230.png"
                  alt="logo"
                  fill
                />
              </AspectRatio>
            </Box>
          </Flex>
          <Text textTransform="uppercase" fontSize={['lg', 'xl', '2xl']}>
            Start with a healthy scalp and inject vitality into your hair.
          </Text>
          <Text
            textTransform="uppercase"
            color={COLOR.YELLOW}
            fontWeight="bold"
            fontSize={['lg', 'xl', '2xl']}
          >
            A new awakening of the scalp, Zero2One radiance | scalp nourishing
            fluid makes you healthy from scratch
          </Text>
          <Text>
            Your scalp needs more care! Zero2One Shine | Scalp Nourishing
            Solution is specially designed for scalp care with natural
            ingredients. Rich Ganoderma lucidum and Salvia miltiorrhiza extracts
            penetrate into the scalp to moisturize, while also bringing
            antioxidant effects. You start with your scalp and feel healthy
            changes.
          </Text>
          <Text>
            Your scalp also needs maintenance. Zero2One Radiant Ganoderma
            Extract gives your scalp the same care as your skin. A new care
            concept that makes your scalp and hair radiate a healthy glow.
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}

export default ProductIntro
